import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'next/router';
import Layout from '~/src/layout/_layout';
import Login from '~/src/layout/login';
import * as base from '~/src/helpers/basePageFunc';
import { isServerSide } from '~/src/helpers/ssr';

class LoginPage extends PureComponent {
    componentDidMount() {
        const { isAuth } = this.props;

        if (isAuth) {
            Router.push({
                pathname: '/',
            });
        }
    }

    render() {
        const { hostname, isAuth, city } = this.props;
        if (isAuth) {
            return null;
        }
        return (
            <Layout
                title='Авторизация в личном кабинете Дом.ру'
                description='Авторизация в личном кабинете Дом.ру. Оплачивайте услуги без комиссии, подключайте новые тарифные планы, воспользуйтесь скидками и подарками для клиентов Дом.ру'
                hostname={hostname}
                withMenu={true}
                withChat={true}
            >
                <Login
                    plAvailable={!!city.plAvailable}
                />
            </Layout>
        );
    }
}

LoginPage.getInitialProps = async(options) => {
    const { res, store } = options;
    const { hostname } = await base.initialProps(options);
    const { city: { currentCity: city }, auth: { isAuth } } = store.getState();

    if (isAuth) {
        if (isServerSide()) {
            res.writeHead(302, { Location: '/' });
            res.end();
            return {};
        } else {
            Router.push('/');
        }
    }

    return { hostname, city };
};

LoginPage.propTypes = {
    hostname: PropTypes.string,
    isAuth: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
    isAuth: state.auth.isAuth,
});

export default connect(mapStateToProps)(LoginPage);
